export const mockData = {
    players: [
      {
        playerId: 1607950,
        rank: 1,
        ratingDisplay: '12.67',
        firstName: 'Madison',
        lastName: 'Keys',
        location: 'Orlando, Florida, United States',
      },
      {
        playerId: 2035498,
        rank: 2,
        ratingDisplay: '12.45',
        firstName: 'Marie',
        lastName: 'Bouzkova',
        location: 'Bradenton, Florida, United States',
      },
      {
        playerId: 47136,
        rank: 3,
        ratingDisplay: '12.26',
        firstName: 'Jacob',
        lastName: 'Walker ',
        location: 'Bethesda, Maryland, United States',
      },
      {
        playerId: 100217,
        rank: 4,
        ratingDisplay: '12.16',
        firstName: 'Coco',
        lastName: 'Gauff',
        location: 'Atlanta, Georgia, United States',
      },
      {
        playerId: 77033,
        rank: 5,
        ratingDisplay: '12.12',
        firstName: 'Christian',
        lastName: 'Alshon',
        location: 'Boca Raton, Florida, United States',
      },
      {
        playerId: 85708,
        rank: 6,
        ratingDisplay: '12.08',
        firstName: 'Joshua',
        lastName: 'Raab',
        location: 'Woodstock, Georgia, United States',
      },
      {
        playerId: 77442,
        rank: 7,
        ratingDisplay: '12.06',
        firstName: 'Catherine',
        lastName: 'McNally',
        location: 'Cincinnati, Ohio, United States',
      },
      {
        playerId: 1708963,
        rank: 8,
        ratingDisplay: '12.00',
        firstName: 'Feliksas',
        lastName: 'Sakalauskas',
        location: 'Fort Myers, Florida, United States',
      },
      {
        playerId: 253551767899,
        rank: 9,
        ratingDisplay: '11.95',
        firstName: 'Flo',
        lastName: 'Free',
        location: 'Bradenton, Florida, United States',
      },
      {
        playerId: 2539359,
        rank: 10,
        ratingDisplay: '11.94',
        firstName: '230',
        lastName: 'PH',
        location: 'Oakland, Florida, United States',
      },
      {
        playerId: 76892,
        rank: 11,
        ratingDisplay: '11.88',
        firstName: 'Claire',
        lastName: 'Liu',
        location: 'Thousand Oaks, California, United States',
      },
      {
        playerId: 2517427,
        rank: 12,
        ratingDisplay: '11.82',
        firstName: 'Emma',
        lastName: 'Navarro',
        location: 'Charleston, South Carolina, United States',
      },
      {
        playerId: 1032485,
        rank: 13,
        ratingDisplay: '11.78',
        firstName: 'Matt',
        lastName: 'Gamble ',
        location: 'Webster, New York, United States',
      },
      {
        playerId: 1313619,
        rank: 14,
        ratingDisplay: '11.72',
        firstName: 'Robin',
        lastName: 'Montgomery',
        location: 'Washington, District of Columbia, United States',
      },
      {
        playerId: 1609434,
        rank: 15,
        ratingDisplay: '11.71',
        firstName: 'Hailey',
        lastName: 'Baptiste',
        location: 'Palo Alto, California, United States',
      },
      {
        playerId: 281134,
        rank: 16,
        ratingDisplay: '11.67',
        firstName: 'Katie',
        lastName: 'Volynets',
        location: 'Palo Alto, California, United States',
      },
      {
        playerId: 1393071,
        rank: 17,
        ratingDisplay: '11.60',
        firstName: 'Ann',
        lastName: 'Li',
        location: 'Devon, Pennsylvania, United States',
      },
      {
        playerId: 765205,
        rank: 18,
        ratingDisplay: '11.59',
        firstName: 'Aliona',
        lastName: 'Bolsova',
        location: 'White Plains, New York, United States',
      },
      {
        playerId: 2535555,
        rank: 19,
        ratingDisplay: '11.57',
        firstName: 'Player',
        lastName: 'E',
        location: 'Orlando, Florida, United States',
      },
      {
        playerId: 1607475,
        rank: 20,
        ratingDisplay: '11.56',
        firstName: 'Varvara',
        lastName: 'Lepchenko',
        location: 'Allentown, Pennsylvania, United States',
      },
      {
        playerId: 1685942,
        rank: 21,
        ratingDisplay: '11.55',
        firstName: 'Renata',
        lastName: 'Zarazua',
        location: 'Palm Beach, Florida, United States',
      },
      {
        playerId: 1609100,
        rank: 22,
        ratingDisplay: '11.52',
        firstName: 'Tara',
        lastName: 'Moore',
        location: 'Miami, Florida, United States',
      },
      {
        playerId: 107276,
        rank: 23,
        ratingDisplay: '11.48',
        firstName: 'Elvina',
        lastName: 'Kalieva',
        location: 'Boca Raton, Florida, United States',
      },
      {
        playerId: 2031220,
        rank: 24,
        ratingDisplay: '11.47',
        firstName: 'Lulu',
        lastName: 'Sun',
        location: 'Naples, Florida, United States',
      },
      {
        playerId: 2074119,
        rank: 25,
        ratingDisplay: '11.47',
        firstName: 'Katarina',
        lastName: 'Jokic',
        location: 'Athens, Georgia, United States',
      },
      {
        playerId: 1712024,
        rank: 26,
        ratingDisplay: '11.47',
        firstName: 'Giuliana',
        lastName: 'Olmos',
        location: 'Santa Monica, California, United States',
      },
      {
        playerId: 107920,
        rank: 27,
        ratingDisplay: '11.44',
        firstName: 'Alycia',
        lastName: 'Parks',
        location: 'Port St. Lucie, Florida, United States',
      },
      {
        playerId: 811379,
        rank: 28,
        ratingDisplay: '11.44',
        firstName: 'Jonathan',
        lastName: 'Mascagni',
        location: 'Lawrenceville, Georgia, United States',
      },
      {
        playerId: 2257509,
        rank: 29,
        ratingDisplay: '11.44',
        firstName: 'Maria',
        lastName: 'Carle',
        location: 'Miami, Florida, United States',
      },
      {
        playerId: 1499085,
        rank: 30,
        ratingDisplay: '11.4',
        firstName: 'Yuriko Lily',
        lastName: 'Miyazaki',
        location: 'Norman, Oklahoma, United States',
      },
      {
        playerId: 412844,
        rank: 31,
        ratingDisplay: '11.38',
        firstName: 'Leolia',
        lastName: 'Jeanjean',
        location: 'Delray Beach, Florida, United States',
      },
      {
        playerId: 2514772,
        rank: 32,
        ratingDisplay: '11.37',
        firstName: 'Conny',
        lastName: 'Perrin',
        location: 'Los Angeles, California, United States',
      },
      {
        playerId: 1609200,
        rank: 33,
        ratingDisplay: '11.36',
        firstName: 'Catherine',
        lastName: 'Harrison',
        location: 'Germantown, Tennessee, United States',
      },
      {
        playerId: 981589,
        rank: 34,
        ratingDisplay: '11.32',
        firstName: 'Mayo',
        lastName: 'Hibi',
        location: 'Irvine, California, United States',
      },
      {
        playerId: 2093432,
        rank: 35,
        ratingDisplay: '11.30',
        firstName: 'Asia',
        lastName: 'Muhammad',
        location: 'Las Vegas, Nevada, United States',
      },
      {
        playerId: 1972277,
        rank: 36,
        ratingDisplay: '11.29',
        firstName: 'Qinwen',
        lastName: 'Zheng',
        location: 'Bradenton, Florida, United States',
      },
      {
        playerId: 260415,
        rank: 37,
        ratingDisplay: '11.27',
        firstName: 'Ashley',
        lastName: 'Lahey',
        location: 'Orlando, Florida, United States',
      },
      {
        playerId: 33118,
        rank: 38,
        ratingDisplay: '11.25',
        firstName: 'Sophie',
        lastName: 'Chang',
        location: 'Havre de Grace, Maryland, United States',
      },
      {
        playerId: 1609716,
        rank: 39,
        ratingDisplay: '11.20',
        firstName: 'Fernanda',
        lastName: 'Contreras',
        location: 'Austin, Texas, United States',
      },
      {
        playerId: 194176,
        rank: 40,
        ratingDisplay: '11.19',
        firstName: 'Ashlyn',
        lastName: 'Krueger',
        location: 'Highland Village, Texas, United States',
      },
      {
        playerId: 2488546,
        rank: 41,
        ratingDisplay: '11.15',
        firstName: 'Grant',
        lastName: 'Durham',
        location: 'Hilton Head Island, South Carolina, United States',
      },
      {
        playerId: 69349,
        rank: 42,
        ratingDisplay: '11.15',
        firstName: 'Hanna',
        lastName: 'Chang',
        location: 'Fontana, California, United States',
      },
      {
        playerId: 1524296,
        rank: 43,
        ratingDisplay: '11.13',
        firstName: 'Sophia',
        lastName: 'Whittle',
        location: 'Nipomo, California, United States',
      },
      {
        playerId: 2524072,
        rank: 44,
        ratingDisplay: '11.13',
        firstName: 'Hurricane Tyra',
        lastName: 'Black',
        location: 'Boca Raton, Florida, United States',
      },
      {
        playerId: 1607102,
        rank: 45,
        ratingDisplay: '11.12',
        firstName: 'Anastasia',
        lastName: 'Nefedova',
        location: 'Palm Harbor, Florida, United States',
      },
      {
        playerId: 999045,
        rank: 46,
        ratingDisplay: '11.11',
        firstName: 'Julia',
        lastName: 'Bahu',
        location: 'Irvine, California, United States',
      },
      {
        playerId: 1609208,
        rank: 47,
        ratingDisplay: '11.10',
        firstName: 'Allie',
        lastName: 'Kiick',
        location: 'Orlando, Florida, United States',
      },
      {
        playerId: 70026,
        rank: 48,
        ratingDisplay: '11.08',
        firstName: 'Austin',
        lastName: 'Yannone',
        location: 'Severna Park, Maryland, United States',
      },
      {
        playerId: 1529701,
        rank: 49,
        ratingDisplay: '11.08',
        firstName: 'Jessica',
        lastName: 'Failla',
        location: 'Ramona, California, United States',
      },
      {
        playerId: 145688,
        rank: 50,
        ratingDisplay: '11.07',
        firstName: 'Reese',
        lastName: 'Brantmeier',
        location: 'Whitewater, Wisconsin, United States',
      },
      {
        playerId: 911486,
        rank: 51,
        ratingDisplay: '11.07',
        firstName: 'Victoria',
        lastName: 'Jimenez Kasintseva',
        location: 'Crestwood, Kentucky, United States',
      },
      {
        playerId: 1018728,
        rank: 52,
        ratingDisplay: '11.06',
        firstName: 'Andrew',
        lastName: 'Pregel ',
        location: 'Cincinnati, Ohio, United States',
      },
      {
        playerId: 269978,
        rank: 53,
        ratingDisplay: '11.06',
        firstName: 'Katarina',
        lastName: 'Kozarov',
        location: 'Greenville, South Carolina, United States',
      },
      {
        playerId: 215092,
        rank: 54,
        ratingDisplay: '11.05',
        firstName: 'Mary',
        lastName: 'Stoiana',
        location: 'Southbury, Connecticut, United States',
      },
      {
        playerId: 47233,
        rank: 55,
        ratingDisplay: '11.04',
        firstName: 'Ena',
        lastName: 'Shibahara',
        location: 'Palos Verdes Estates, California, United States',
      },
      {
        playerId: 2062589,
        rank: 56,
        ratingDisplay: '11.03',
        firstName: 'Vanessa',
        lastName: 'Ong',
        location: 'Oklahoma City, Oklahoma, United States',
      },
      {
        playerId: 22990,
        rank: 57,
        ratingDisplay: '11.02',
        firstName: 'Pamela',
        lastName: 'Montez',
        location: 'La Quinta, California, United States',
      },
      {
        playerId: 1500488,
        rank: 58,
        ratingDisplay: '11.01',
        firstName: 'Makenna',
        lastName: 'Jones',
        location: 'Greenville, South Carolina, United States',
      },
      {
        playerId: 189285,
        rank: 59,
        ratingDisplay: '10.98',
        firstName: 'Alexandra',
        lastName: 'Yepifanova',
        location: 'Bradenton, Florida, United States',
      },
      {
        playerId: 56492,
        rank: 60,
        ratingDisplay: '10.98',
        firstName: 'Vladica',
        lastName: 'BABIC',
        location: 'Stillwater, Oklahoma, United States',
      },
      {
        playerId: 293355,
        rank: 61,
        ratingDisplay: '10.97',
        firstName: 'Ana',
        lastName: 'GELLER',
        location: 'Bradenton, Florida, United States',
      },
      {
        playerId: 654348,
        rank: 62,
        ratingDisplay: '10.97',
        firstName: 'Celia',
        lastName: 'Cervino Ruiz',
        location: 'Greenville, North Carolina, United States',
      },
      {
        playerId: 2100412,
        rank: 63,
        ratingDisplay: '10.96',
        firstName: 'Lucía',
        lastName: 'Cervera Vázquez',
        location: 'Charlotte, North Carolina, United States',
      },
      {
        playerId: 39501,
        rank: 64,
        ratingDisplay: '10.96',
        firstName: 'Alexa',
        lastName: 'Graham',
        location: 'Garden City South, New York, United States',
      },
      {
        playerId: 2096652,
        rank: 65,
        ratingDisplay: '10.96',
        firstName: 'Whitney',
        lastName: 'Osuigwe',
        location: 'Bradenton, Florida, United States',
      },
      {
        playerId: 1027555,
        rank: 66,
        ratingDisplay: '10.95',
        firstName: 'Evgeniya',
        lastName: 'Levashova',
        location: 'Malibu, California, United States',
      },
      {
        playerId: 1298962,
        rank: 67,
        ratingDisplay: '10.95',
        firstName: 'Justina',
        lastName: 'MIKULSKYTE',
        location: 'Lexington, Kentucky, United States',
      },
      {
        playerId: 1682354,
        rank: 68,
        ratingDisplay: '10.93',
        firstName: 'Abigail',
        lastName: 'Forbes ',
        location: 'Raleigh, North Carolina, United States',
      },
      {
        playerId: 1040786,
        rank: 69,
        ratingDisplay: '10.93',
        firstName: 'Brynn',
        lastName: 'Boren',
        location: 'Laguna Beach, California, United States',
      },
      {
        playerId: 1551741,
        rank: 70,
        ratingDisplay: '10.93',
        firstName: 'Elizabeth',
        lastName: 'Mandlik',
        location: 'Palo Alto, California, United States',
      },
      {
        playerId: 1609094,
        rank: 71,
        ratingDisplay: '10.91',
        firstName: 'Alexa',
        lastName: 'Glatch',
        location: 'Santa Monica, California, United States',
      },
      {
        playerId: 261311,
        rank: 72,
        ratingDisplay: '10.90',
        firstName: 'Isabella',
        lastName: 'Kruger',
        location: 'Bradenton, Florida, United States',
      },
      {
        playerId: 1708888,
        rank: 73,
        ratingDisplay: '10.89',
        firstName: 'Angelica',
        lastName: 'Blake ',
        location: 'Boca Raton, Florida, United States',
      },
      {
        playerId: 97455,
        rank: 74,
        ratingDisplay: '10.89',
        firstName: 'Dalayna',
        lastName: 'Hewitt',
        location: 'Cleveland, Ohio, United States',
      },
      {
        playerId: 2129275,
        rank: 75,
        ratingDisplay: '10.89',
        firstName: 'Savannah',
        lastName: 'Broadus',
        location: 'Carrollton, Texas, United States',
      },
      {
        playerId: 247273,
        rank: 76,
        ratingDisplay: '10.88',
        firstName: 'Jessie',
        lastName: 'Aney',
        location: 'Hartford, Connecticut, United States',
      },
      {
        playerId: 1532556,
        rank: 77,
        ratingDisplay: '10.87',
        firstName: 'Andie',
        lastName: 'K. DANIELL',
        location: 'Douglasville, Georgia, United States',
      },
      {
        playerId: 50623,
        rank: 78,
        ratingDisplay: '10.87',
        firstName: 'Kelly',
        lastName: 'Chen',
        location: 'Cerritos, California, United States',
      },
      {
        playerId: 1947571,
        rank: 79,
        ratingDisplay: '10.86',
        firstName: 'Dorka',
        lastName: 'Drahota Szabo',
        location: 'Irvine, California, United States',
      },
      {
        playerId: 1983491,
        rank: 80,
        ratingDisplay: '10.85',
        firstName: 'Varvara',
        lastName: 'Flink',
        location: 'Windermere, Florida, United States',
      },
      {
        playerId: 1060776,
        rank: 81,
        ratingDisplay: '10.84',
        firstName: 'Clervie',
        lastName: 'Ngounoue',
        location: 'Washington, District of Columbia, United States',
      },
      {
        playerId: 926109,
        rank: 82,
        ratingDisplay: '10.83',
        firstName: 'Lorraine',
        lastName: 'Guillermo',
        location: 'Walnut, California, United States',
      },
      {
        playerId: 1619009,
        rank: 83,
        ratingDisplay: '10.83',
        firstName: 'Rasheeda',
        lastName: 'McAdoo',
        location: 'Boca Raton, Florida, United States',
      },
      {
        playerId: 1962750,
        rank: 84,
        ratingDisplay: '10.82',
        firstName: 'Ingrid',
        lastName: 'Martins',
        location: 'Columbia, South Carolina, United States',
      },
      {
        playerId: 94694,
        rank: 86,
        ratingDisplay: '10.8',
        firstName: 'Cameron',
        lastName: 'Morra ',
        location: 'Rockville, Maryland, United States',
      },
      {
        playerId: 91583,
        rank: 87,
        ratingDisplay: '10.79',
        firstName: 'Dasha',
        lastName: 'Ivanova',
        location: 'Beaverton, Oregon, United States',
      },
      {
        playerId: 360444,
        rank: 88,
        ratingDisplay: '10.79',
        firstName: 'Saki',
        lastName: 'Imamura',
        location: 'Oak Brook, Illinois, United States',
      },
      {
        playerId: 2170423,
        rank: 89,
        ratingDisplay: '10.77',
        firstName: 'Sabina',
        lastName: 'Machalova',
        location: 'Oxford, Mississippi, United States',
      },
      {
        playerId: 2280066,
        rank: 90,
        ratingDisplay: '10.76',
        firstName: 'Katerina',
        lastName: 'Stewart',
        location: 'Miami, Florida, United States',
      },
      {
        playerId: 806562,
        rank: 91,
        ratingDisplay: '10.76',
        firstName: 'Elizabeth',
        lastName: 'Coleman',
        location: 'Midland, Michigan, United States',
      },
      {
        playerId: 2523246,
        rank: 92,
        ratingDisplay: '10.75',
        firstName: 'Melany',
        lastName: 'Krywoj',
        location: 'Waco, Texas, United States',
      },
      {
        playerId: 2272025,
        rank: 93,
        ratingDisplay: '10.74',
        firstName: 'Panna',
        lastName: 'Udvardy',
        location: 'Jupiter, Florida, United States',
      },
      {
        playerId: 2511980,
        rank: 94,
        ratingDisplay: '10.74',
        firstName: 'Natasha',
        lastName: 'Subhash',
        location: 'Fairfax, Virginia, United States',
      },
      {
        playerId: 10463,
        rank: 95,
        ratingDisplay: '10.73',
        firstName: 'Zuzana',
        lastName: 'Zlochova',
        location: 'Lake Worth, Florida, United States',
      },
      {
        playerId: 96391,
        rank: 96,
        ratingDisplay: '10.73',
        firstName: 'Charlotte',
        lastName: 'Chavatipon',
        location: 'Fullerton, California, United States',
      },
      {
        playerId: 2138646,
        rank: 97,
        ratingDisplay: '10.72',
        firstName: 'MARINE',
        lastName: 'PARTAUD',
        location: 'Delray Beach, Florida, United States',
      },
      {
        playerId: 95681,
        rank: 98,
        ratingDisplay: '10.72',
        firstName: 'Jaedan',
        lastName: 'Brown',
        location: 'Granger, Indiana, United States',
      },
      {
        playerId: 1651889,
        rank: 99,
        ratingDisplay: '10.72',
        firstName: 'Daria',
        lastName: 'Frayman',
        location: 'Princeton, New Jersey, United States',
      },
      {
        playerId: 1609669,
        rank: 100,
        ratingDisplay: '10.70',
        firstName: 'Fiona',
        lastName: 'Crawley',
        location: 'San Antonio, Texas, United States',
      },
    ],
};
